<template>
  <div class="col-12 col-md-6">
    <div class="btn-disc" :class="definirEstiloCategoria(curso.categoria)">
      <b-link v-b-toggle="'col-caderno-' + id">
        {{ curso.nome }}
      </b-link>

      <b-collapse :id="'col-caderno-' + id">
        <ul>
          <li v-for="(licao, index) in licoes" :key="'licao-' + index">
            <a href="javascript:void(0)" @click="abrirModalCaderno(curso, licao)"><i class="fas fa-book"></i> {{ licao.nome }}</a>
          </li>
        </ul>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CadernoCursoCollapse',
  data () {
    return {
      id: '',
      licoes: {}
    }
  },
  props: {
    curso: Object
  },
  mounted () {
    this.id = this._uid

    this.licoes = this.curso.modulos.flatMap(modulo => modulo.licoes)
  },
  methods: {
    definirEstiloCategoria: function (categoria) {
      if (categoria === 'Categoria 1') {
        return 'cat1'
      } else if (categoria === 'Categoria 2') {
        return 'cat2'
      } else if (categoria === 'Categoria 3') {
        return 'cat3'
      } else if (categoria === 'Categoria 4') {
        return 'cat4'
      } else {
        return 'cat1'
      }
    },
    abrirModalCaderno: function (curso, licao) {
      let licaoEscolhida = Object.assign({}, licao)
      licaoEscolhida.curso = Object.assign({}, curso)
      this.$emit('cadernoEscolhidoChange', licaoEscolhida)

      this.$bvModal.show('modalCaderno')
    }
  }
}
</script>

<style scoped>

</style>
